import { useContext } from 'react';
import { HistoryContext } from './HistoryContext';

/**
 * A hook to retrieve history.
 */
export const useHistory = () => {
  const { history } = useContext(HistoryContext);

  return history;
};
